import React from 'react'
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import PopInRightPanel from '../components/PopInRightPanel';
import CardsTable from '../components/CardsTable';

function Cards() {
  return (
    <>
    <main className="main-content border-radius-lg ">
    <NavBar/>   
    <CardsTable/>
    <Footer/>
    </main>
    <PopInRightPanel/>
    </>
  )
}

export default Cards
